var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.65,2.6 C2.1043265,2.6 0,4.48353916 0,7.18674869 C0,8.16567941 0.277599833,9.21288301 0.7265625,10.0003765 L4.34861111,16.3549407 C4.40928935,16.4630722 4.52470449,16.5301784 4.65,16.5301784 C4.77529551,16.5301784 4.89071065,16.4630722 4.95138889,16.3549407 L8.5734375,10.0003765 C9.02241739,9.21284904 9.3,8.16567941 9.3,7.18674869 C9.3,4.48353916 7.1956735,2.6 4.65,2.6 Z M4.65,3.27951807 C6.86011572,3.27951807 8.61111111,4.82357 8.61111111,7.18674869 C8.61111111,8.03378495 8.34817083,9.00376302 7.97065972,9.6659347 L4.65,15.4896084 L1.32934028,9.6659347 C0.951846389,9.003797 0.688888889,8.03378495 0.688888889,7.18674869 C0.688888889,4.82357 2.43988428,3.27951807 4.65,3.27951807 Z M4.65,4.97831325 C3.41757089,4.97831325 2.41111111,5.97110614 2.41111111,7.18674869 C2.41111111,8.40240652 3.41757433,9.39518072 4.65,9.39518072 C5.88242567,9.39518072 6.88888889,8.40240652 6.88888889,7.18674869 C6.88888889,5.97110614 5.88242911,4.97831325 4.65,4.97831325 Z M4.65,5.65783133 C5.51011567,5.65783133 6.2,6.33835339 6.2,7.18674869 C6.2,8.03516098 5.51011911,8.71566435 4.65,8.71566435 C3.78988089,8.71566435 3.1,8.03516098 3.1,7.18674869 C3.1,6.33835339 3.78988433,5.65783133 4.65,5.65783133 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-comments",
    transform: "translate(-91.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(91.000000, 312.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLocationEvent",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationEvent);
export default __webpack_public_path__ + "static/media/icLocationEvent.d30e73c9c7ec282221fab6b460453141.svg";
export { ForwardRef as ReactComponent };